var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",attrs:{"id":"dashboard"}},[_c('img',{staticStyle:{"width":"600px","height":"40%","object-fit":"contain"},attrs:{"src":require("@/assets/logo_full.svg"),"alt":""}}),(_vm.user.role==1)?_c('LoginCardTable'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }